module.exports = __webpack_public_path__ + "img/IMG-20200311-WA0015.ddd3d839.jpg";